export default __webpack_public_path__ + "24ae8eed8d133412572419a82b51e430.png";